import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'AgentProfileEditor',
  properties: {},

  statics: {
    breadcrumb: 'Agent Profile',
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/agent_profile_editor.js